export function calculateOfficeSchemeFee(estimateAmount) {
  const totalEstimate = Number(estimateAmount) || 0;

  const consultancyFee = Math.round(totalEstimate * 0.015);
  const cgst = Math.round(consultancyFee * 0.09);
  const sgst = Math.round(consultancyFee * 0.09);
  const totalGst = cgst + sgst;
  const grandTotal = consultancyFee + totalGst;

  return {
    totalEstimate,
    consultancyFee,
    cgst,
    sgst,
    totalGst,
    grandTotal,
  };
}

export function formatINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0);
}